import React from 'react';
import { Button, Col, Row, Typography } from 'antd';
import { useParams } from 'react-router';
import buskwarehousedetail from '@modules/Busk/BuskWarehouseDetail/services/buskwarehousedetail';

interface IProps {
  totalDeliveries: number;
  selectedDeliveries: React.Key[];
}
const ShippingListHead = ({
  totalDeliveries,
  selectedDeliveries
}: IProps) => {
  const { id } = useParams<{ id: string }>();

  const handleExport = async () => {
    if (selectedDeliveries.length > 0) {
      const response =
        await buskwarehousedetail.exportDeliveries(
          id,
          selectedDeliveries
        );
      const outputFilename = `Delivery_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response =
        await buskwarehousedetail.exportDeliveries(
          id
        );
      const outputFilename = `Delivery_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  }

  return (
    <div className="busk-sellerSubHead">
      <Row align="middle">
        <Col flex="auto">
          <Row gutter={15}>
            <Col>
              <Typography.Text>총 배송 {totalDeliveries}</Typography.Text>
            </Col>
            <Col>|</Col>
            <Col>
              <Typography.Text>
                선택 배송 {selectedDeliveries.length}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleExport()}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default ShippingListHead;